import React from "react";

import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";

import styles from "./styles.modules.scss";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { EsportCarouselControllerView } from "./esport-carousel/view";
import { EsportCarousel } from "supercell-frontend-base/src/components/esport/esport-carousel";
import { EsportSlide } from "supercell-frontend-base/src/components/esport/types";
import { FullscreenEntryContainer } from "supercell-frontend-base/src/components/fullscreen-entry";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";
import { useLocation } from "react-router-dom";
import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";
import { ClashOfClansGameParams } from "validation/game-params";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";

export const EsportView = () => {
    const { trackPageView } = useSnowplowContext();
    const { pathname: pagePath } = useLocation();

    React.useEffect(() => {
        trackPageView("Esport", pagePath);
        window.history.pushState({ home: true }, "");
    }, []);

    return (
        <Tab namespace="esport">
            {({
                data: {
                    articles,
                    socialLinks,
                    carouselItems,
                    fullscreenEntries,
                },
                locale,
            }) => {
                const { gameParams } =
                    useGameParamsContext<ClashOfClansGameParams>();

                const filterArticles = (a: InboxArticle) =>
                    filterNewsFeed(a) && filterEntry(a, gameParams);

                return (
                    <FullscreenEntryContainer
                        tab="esport"
                        entries={fullscreenEntries.filter((e) =>
                            filterEntry(e, gameParams),
                        )}
                    >
                        <div className={`esport ${styles.esport}`}>
                            <Grid>
                                <div className={`events ${styles.events}`}>
                                    <EsportCarousel
                                        view={EsportCarouselControllerView}
                                        locale={locale}
                                        slides={
                                            carouselItems.filter((item) =>
                                                filterEntry(item, gameParams),
                                            ) as EsportSlide[]
                                        }
                                    />
                                </div>

                                <div className={`articles ${styles.articles}`}>
                                    <List
                                        header={null}
                                        Item={ListArticle}
                                        items={
                                            articles.filter(
                                                filterArticles,
                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            ) as any[][]
                                        }
                                        columns={1}
                                        perPage={4}
                                        footer={
                                            <>
                                                <ContentfulSocialLinks
                                                    titleLabel="globalText.langFollowMore"
                                                    links={
                                                        socialLinks as SocialLink[]
                                                    }
                                                />
                                            </>
                                        }
                                    />
                                </div>
                            </Grid>
                        </div>
                    </FullscreenEntryContainer>
                );
            }}
        </Tab>
    );
};
